// import {
//   CharityPagePayload,
//   CharityPageUpdatePayload,
//   UpdateCharityFieldPayload,
// } from "@/models/charity";
// import { PayloadAction, createSlice } from "@reduxjs/toolkit";

// // Define a type for the slice state
// interface CharityState {
//   charity: CharityPagePayload | null;
// }
// // Define the initial state using that type
// const initialState: CharityState = {
//   charity: null,
// };

// export const charitySlice = createSlice({
//   name: "charity",
//   initialState,
//   reducers: {
//     setCharity: (state, action: PayloadAction<CharityPagePayload>) => {
//       state.charity = action.payload;
//     },

//     // only for textfields
//     updateCharityField: (
//       state,
//       action: PayloadAction<UpdateCharityFieldPayload>
//     ) => {
//       const { field, value } = action.payload;
//       if (state.charity) {
//         state.charity[field] = value;
//       }
//     },

//     // New reducer for handling CharityPageUpdatePayload
//     updateSidebarCharityPage: (
//       state,
//       action: PayloadAction<CharityPageUpdatePayload>
//     ) => {
//       const { tags, countriesActive, weblink, reachOutEmail, foundedDate } =
//         action.payload;
//       if (state.charity) {
//         // Assuming you want to replace the existing arrays wholly
//         state.charity.tags = tags;
//         state.charity.countriesActive = countriesActive;
//         state.charity.weblink = weblink;
//         state.charity.reachOutEmail = reachOutEmail;
//         state.charity.foundedDate = foundedDate;
//       }
//     },
//   },
// });
// export const { setCharity, updateCharityField, updateSidebarCharityPage } =
//   charitySlice.actions;

// // Export the reducer as default
// export default charitySlice.reducer;






import {
  CharityPagePayload,
  CharityPageUpdatePayload,
  UpdateCharityFieldPayload,
} from "@/models/charity";
import { PayloadAction, createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// Define a type for the slice state
interface CharityState {
  charity: CharityPagePayload | null;
  loading: boolean;
  error: string | null;
}

// Define the initial state using that type
const initialState: CharityState = {
  charity: null,
  loading: false,
  error: null,
};

// Create an async thunk for fetching charity data
export const fetchCharity = createAsyncThunk(
  "charity/fetchCharity",
  async (charityId: string) => {
    const response = await fetch(`/charity/${charityId}`);
    if (!response.ok) {
      throw new Error("Failed to fetch charity data");
    }
    return response.json();
  },
);

export const charitySlice = createSlice({
  name: "charity",
  initialState,
  reducers: {
    setCharity: (state, action: PayloadAction<CharityPagePayload>) => {
      state.charity = action.payload;
    },

    updateCharityField: (
      state,
      action: PayloadAction<UpdateCharityFieldPayload>,
    ) => {
      const { field, value } = action.payload;
      if (state.charity) {
        state.charity[field] = value;
      }
    },

    updateSidebarCharityPage: (
      state,
      action: PayloadAction<CharityPageUpdatePayload>,
    ) => {
      const { tags, countriesActive, weblink, reachOutEmail, foundedDate } =
        action.payload;
      if (state.charity) {
        state.charity.tags = tags;
        state.charity.countriesActive = countriesActive;
        state.charity.weblink = weblink;
        state.charity.reachOutEmail = reachOutEmail;
        state.charity.foundedDate = foundedDate;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCharity.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCharity.fulfilled, (state, action) => {
        state.loading = false;
        state.charity = action.payload;
      })
      .addCase(fetchCharity.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch charity data";
      });
  },
});

export const { setCharity, updateCharityField, updateSidebarCharityPage } =
  charitySlice.actions;

// Export the reducer as default
export default charitySlice.reducer;
